import {database} from '../firebase';
import {snapshotToArray} from '../helpers';

export const FETCH_DEPENDENCIES  = 'FETCH_DEPENDENCIES';

export const updateDependency = (dependency) => async dispatch => {
    let updates = {};
    updates['/dependencies/' + dependency.key] = dependency;
    

    database.ref().update(updates).then(function(value) {
        // dispatch({
        //     type: UPDATE_ACTIVITY,
        //     payload: activity
        // });
    });;
  
};

export const addDependency = (dependency) => async dispatch => {
    // database.ref("/activities").push(activity).then(function(value) {
    //     activity.key = value.key;
    //     dispatch(updateActivities(activity));
    // });

};

export const fetchDependencies = () => async dispatch => {
    
    database.ref("/dependencies").once("value", snapshot => {
      	dispatch({
        	type: FETCH_DEPENDENCIES,
        	payload: snapshotToArray(snapshot)
      	});
  	});
};